// Do not Bundle ES6 Modules
window.addEventListener('DOMContentLoaded', () => {

    // vars
    // -----------
    var ajaxurl = '/wp/wp-admin/admin-ajax.php';
    var libs = {};
    var filterYear = 0;
    var filterBrand = '';
    //var slug = 'all';

    //typeとlabelの対応
    // var categoryMap = {
    //     "ytj": "YA-MAN TOKYO JAPAN",
    //     "myse": "myse",
    //     "only-minerals": "ONLY MINERALS"
    // };
    var easyDeffered = {
        local: false
    };
    var isInit = true;
    //var isThreeYear = false;

    // var body = document.getElementsByTagName('body')[0];
    // var html = document.getElementsByTagName('html')[0];


    // functions
    // -----------
    var complete = function (key, callback) {
        easyDeffered[key] = true;
        var result = true;
        [].forEach.call(easyDeffered, function (v) {
            if (v === false) {
                result = false;
                return false;
            }
        });
        if (result && callback) {
            callback();
        }
        //console.log('-- complete --');
    };

    var output = function () {
        console.log('-- output --');
        console.log(libs);
        console.log(libs.items.length);

        var el = '';
        var sameProFlg = [];
        var sameProdElems = []; //同じ商品の賞のHTML断片


        // IE11にてincludes利用できず
        if (!Array.prototype.includes) {
            Object.defineProperty(Array.prototype, 'includes', {
                value: function (searchElement, fromIndex) {
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }
                    var o = Object(this);
                    var len = o.length >>> 0;

                    if (len === 0) {
                        return false;
                    }
                    var n = fromIndex | 0;
                    var ll = len - Math.abs(n);
                    var k = Math.max(n >= 0 ? n : ll, 0);
                    while (k < len) {
                        if (o[k] === searchElement) {
                            return true;
                        }
                        k++;
                    }
                    return false;
                }
            });
        }


        [].forEach.call(libs.items, function (list, index) {

            if (!sameProFlg.includes(list.awards_category_lv2)) {
                //初出の商品の場合
                sameProFlg.push(list.awards_category_lv2);

                el += '<div class="awards" id="' + list.awards_category_lv2 + '">';
                var img1 = '';
                if (list.prod_img == null) {
                    img1 = '/wp/wp-content/themes/corporate-ym/assets/img/no-image/300x300.jpg';
                } else {
                    img1 = list.prod_img;
                }
                el += '<div class="awards__image"><img src="' + img1 + '"  loading="lazy" alt="' + list.awards_category_lv2_label + '" width="150" height="150"></div>';


                el += '<div class="awards__category ' + list.awards_category_lv1 + '">' + list.awards_category_lv1_label + '</div>';

                el += '<div class="awards__name" data-prod="' + list.awards_category_lv2 + '">' + list.awards_category_lv2_label + '</div>';


                el += '<div class="awards__list">';
                el += '    <div class="awards-list">';
                el += '        <div class="awards-list__item">';
                el += '            <div>';
                el += '                <p>' + list.title + '</p>';
                el += '                <p>' + list.text_body + '</p>';


                // el += '                <details class="viewmore">';
                // el += '                   <summary>View More</summary>';
                // el += '                   <div class="viewmore-detail" id="' + list.awards_category_lv2 + '_more-container"></div>';
                // el += '                </details>';


                el += '            </div>';
                if (list.awards_img !== '') {
                    el += '            <img src="' + list.awards_img + '"  loading="lazy" alt="' + list.title + '">';
                }
                el += '        </div>';


                el += '        <details class="viewmore">';
                el += '           <summary>View More<img class="icon-arrow-down" src="/wp/wp-content/themes/corporate-ym/assets/img/common/icon-arrow-down.svg"></summary>';
                el += '           <div class="viewmore-detail" id="' + list.awards_category_lv2 + '_more-container"></div>';
                el += '        </details>';


                el += '    </div>';
                el += '</div>';

                
                el += '<div class="awards__link">';
                if(list.prod_link){
                el += '    <a target="_blank" href="' + list.prod_link + '" class="awards-button-rect">';

                if(list.awards_category_lv1 == 'corporate'){
                    el += '詳細を見る';
                }else{
                    el += '商品詳細を見る';
                }

                el += '<img class="icon-blank" src="/wp/wp-content/themes/corporate-ym/assets/img/common/icon_blank.svg">';
                el += '</a>';
                }
                el += '</div>';
                

                
                el += '</div>';


            } else {
                //一度表示した商品の場合
                //console.log(list.awards_category_lv2 + ', ' + list.title);

                var elMore = '';
                elMore += '<div class="viewmore-detail-row">';


                elMore += '<div class="viewmore-detail-col';
                if (list.awards_img !== '') {
                    elMore += ' has-thumb';
                } else {
                    //elMore += ' has-thumb';
                    elMore += ' w100p';
                }
                elMore += '">';
                elMore += '<p class="">' + list.title + '</p>';
                elMore += '<p>' + list.text_body + '</p>';
                elMore += '</div>';

                if (list.awards_img !== '') {
                    elMore += '<div class="viewmore-detail-col">';
                    elMore += '            <img src="' + list.awards_img + '"  loading="lazy" alt="' + list.title + '">';
                    elMore += '</div>';
                } else {
                    //elMore += '<div class="viewmore-detail-col"></div>';
                }

                elMore += '</div>';
                if (sameProdElems[list.awards_category_lv2] == undefined) {
                    sameProdElems[list.awards_category_lv2] = elMore;
                } else {
                    sameProdElems[list.awards_category_lv2] = sameProdElems[list.awards_category_lv2] + elMore;
                }
            }

        });

        
        if(libs.items.length === 0){
            // 0件の場合
            el = '<div class="awards is-center"><p>該当はありません</div>';
        }
        document.getElementById('awards-list').insertAdjacentHTML('beforeend', el);


        window.setTimeout(() => {
            //console.log(sameProdElems);
            for (let key in sameProdElems) {
                //console.log(key);
                if (document.getElementById(key + '_more-container')) {
                    let targetElem = document.getElementById(key + '_more-container');
                    //console.log(targetElem);
                    //console.log(key + '_more-container');
                    targetElem.insertAdjacentHTML('beforeend', sameProdElems[key]);
                    targetElem.parentElement.classList.add('is-show');
                }
            }
        }, 200);
    };


    var convertData = function (data) {
        //console.log('-- original Data --');
        //console.log(data);

        libs = {
            headline: "",
            items: []
        };

        if (data.item_count) {

            [].forEach.call(data.item, function (list, index) {
                libs.items.push({
                    date: list.format_date,
                    title: list.title, //雑誌名など
                    text_body: list.text_body, //賞

                    // 親カテゴリ（ブランド）
                    awards_category_lv1: list.awards_category_lv1,
                    awards_category_lv1_label: list.awards_category_lv1_label,

                    // カテゴリ（商品）
                    awards_category_lv2: list.awards_category_lv2,
                    awards_category_lv2_label: list.awards_category_lv2_label,
                    awards_img: list.awards_img,

                    prod_img: list.prod_img,
                    prod_link: list.prod_link,
                });

            });
        }

        //console.log('-- converted Data --');
        //console.log(libs);
    };


    //_var mask = function (selector) {};

    //var unmask = function () {};

    // Ajax
    // -----------
    var loadData = function () {
        var request = new XMLHttpRequest();


        // パラメータ確認: 年月(半期で指定 20xx-01,20yy-06)
        var yearParam = 0;
        filterYear = document.getElementById('yearSelect').value
        //数字ではない(20xx-1,20xx-7) parseInt(parseInt(document.getElementById('yearSelect').value), 10);
        if (filterYear == 0) {
            yearParam = '';
        } else {
            yearParam = '&year=' + filterYear;
        }

        // パラメータ確認: ブランド
        var brandParam = '';
        if (document.querySelectorAll('.js-btn-brand.selected')[0]) {
            filterBrand = document.querySelectorAll('.js-btn-brand.selected')[0].dataset.brand;
            if (filterBrand == 'all') {
                brandParam = '';
            } else {
                brandParam = '&brand=' + filterBrand;
            }
        } else {
            brandParam = '';
        }

        // リスト表示をリセット
        var myNode = document.getElementById("awards-list");
        while (myNode.firstChild) {
            myNode.removeChild(myNode.lastChild);
        }
        request.open('GET', ajaxurl + '?action=get_awards' + yearParam + brandParam, true);
        //request.open('GET', ajaxurl + '?action=get_awards' + yearParam + brandParam, true, 'yamancom', 'yaman0325');
        //request.open('GET', ajaxurl + '?action=get_awards' + yearParam + brandParam, true, 'kata', 'dspga');
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                console.log("Ajax Success");
                if (request) {
                    if (filterYear > 0) {
                        isInit = false;
                    }
                    libs = {};
                    let data = JSON.parse(request.responseText);
                    //console.log(data);
                    convertData(data);//libsを作成
                    complete("local", output);
                }
                
            } else {
                console.log("Ajax Fail");
            }
        };
        request.onerror = function () {
            console.log("Ajax Error")
        };
        request.send();
    }
    loadData();


    //年度セレクタ変更時
    if (document.getElementById('yearSelect')) {
        document.getElementById('yearSelect').addEventListener('change', function (e) {
            //mask("#content .entry-content");
            //var year = e.currentTarget.value;
            loadData();
        });
    }

    //ブランド変更時
    if (document.querySelectorAll('.js-btn-brand')[0]) {
        var brandBtns = document.querySelectorAll('.js-btn-brand');
        [].forEach.call(brandBtns, (elem, index) => {
            elem.addEventListener('click', () => {

                var brandBtns2 = document.querySelectorAll('.js-btn-brand');
                [].forEach.call(brandBtns2, (elem2, index) => {
                    elem2.classList.remove('selected');
                });

                elem.classList.add('selected');
                loadData();
            });
        });
    }



});